export const TKeyBrand = {
  BRAND_CHARTER_TITLE: "BRAND_CHARTER_TITLE",
  BRAND_CHARTER_SUBTITLE: "BRAND_CHARTER_SUBTITLE",
  BRAND_CHARTER_GROUP_BRAND: "BRAND_CHARTER_GROUP_BRAND",
  BRAND_CHARTER_GROUP_BRAND_TEXT: "BRAND_CHARTER_GROUP_BRAND_TEXT",
  BRAND_CHARTER_GROUP_NEUTRAL: "BRAND_CHARTER_GROUP_NEUTRAL",
  BRAND_CHARTER_GROUP_NEUTRAL_TEXT: "BRAND_CHARTER_GROUP_NEUTRAL_TEXT",
  BRAND_CHARTER_GROUP_SEMANTIC: "BRAND_CHARTER_GROUP_SEMANTIC",
  BRAND_CHARTER_GROUP_SEMANTIC_TEXT: "BRAND_CHARTER_GROUP_SEMANTIC_TEXT",
  BRAND_CHARTER_GROUP_ACCENT: "BRAND_CHARTER_GROUP_ACCENT",
  BRAND_CHARTER_GROUP_ACCENT_TEXT: "BRAND_CHARTER_GROUP_ACCENT_TEXT",
  BRAND_CHARTER_TYPE_TITLE: "BRAND_CHARTER_TYPE_TITLE",
  BRAND_CHARTER_TYPE_TEXT: "BRAND_CHARTER_TYPE_TEXT",
  BRAND_CHARTER_TYPE_ROLE_HEADING: "BRAND_CHARTER_TYPE_ROLE_HEADING",
  BRAND_CHARTER_TYPE_ROLE_EMPHASIS: "BRAND_CHARTER_TYPE_ROLE_EMPHASIS",
  BRAND_CHARTER_TYPE_ROLE_SIGNATURE: "BRAND_CHARTER_TYPE_ROLE_SIGNATURE",
  BRAND_CHARTER_TYPE_ROLE_BODY: "BRAND_CHARTER_TYPE_ROLE_BODY",
  BRAND_CHARTER_TYPE_SAMPLE_HEADING: "BRAND_CHARTER_TYPE_SAMPLE_HEADING",
  BRAND_CHARTER_TYPE_SAMPLE_EMPHASIS: "BRAND_CHARTER_TYPE_SAMPLE_EMPHASIS",
  BRAND_CHARTER_TYPE_SAMPLE_BODY: "BRAND_CHARTER_TYPE_SAMPLE_BODY",
  BRAND_CHARTER_CONTRAST_TITLE: "BRAND_CHARTER_CONTRAST_TITLE",
  BRAND_CHARTER_CONTRAST_TEXT: "BRAND_CHARTER_CONTRAST_TEXT",
  BRAND_CHARTER_CONTRAST_COL_TOKEN: "BRAND_CHARTER_CONTRAST_COL_TOKEN",
  BRAND_CHARTER_CONTRAST_COL_RATIO: "BRAND_CHARTER_CONTRAST_COL_RATIO",
  BRAND_CHARTER_CONTRAST_COL_USAGE: "BRAND_CHARTER_CONTRAST_COL_USAGE",
  BRAND_CHARTER_CONTRAST_PASS: "BRAND_CHARTER_CONTRAST_PASS",
  BRAND_CHARTER_CONTRAST_FAIL: "BRAND_CHARTER_CONTRAST_FAIL",
  BRAND_CHARTER_USAGE_BODY: "BRAND_CHARTER_USAGE_BODY",
  BRAND_CHARTER_USAGE_SECONDARY: "BRAND_CHARTER_USAGE_SECONDARY",
  BRAND_CHARTER_USAGE_ACCENT: "BRAND_CHARTER_USAGE_ACCENT",
  BRAND_CHARTER_USAGE_LABEL: "BRAND_CHARTER_USAGE_LABEL",
  BRAND_CHARTER_USAGE_OUTLINE: "BRAND_CHARTER_USAGE_OUTLINE",
  BRAND_CHARTER_USAGE_MUTED: "BRAND_CHARTER_USAGE_MUTED",
  BRAND_CHARTER_USAGE_GLOW: "BRAND_CHARTER_USAGE_GLOW",
  BRAND_CHARTER_NOTE: "BRAND_CHARTER_NOTE",
  BRAND_CHARTER_SCALE_TITLE: "BRAND_CHARTER_SCALE_TITLE",
  BRAND_CHARTER_SCALE_TEXT: "BRAND_CHARTER_SCALE_TEXT",
  BRAND_CHARTER_SPACING_TITLE: "BRAND_CHARTER_SPACING_TITLE",
  BRAND_CHARTER_SPACING_TEXT: "BRAND_CHARTER_SPACING_TEXT",
  BRAND_CHARTER_PRINCIPLES_TITLE: "BRAND_CHARTER_PRINCIPLES_TITLE",
  BRAND_CHARTER_PRINCIPLES_TEXT: "BRAND_CHARTER_PRINCIPLES_TEXT",
  BRAND_CHARTER_PRINCIPLE_ACCENT: "BRAND_CHARTER_PRINCIPLE_ACCENT",
  BRAND_CHARTER_PRINCIPLE_FLOURISH: "BRAND_CHARTER_PRINCIPLE_FLOURISH",
  BRAND_CHARTER_PRINCIPLE_CHIPS: "BRAND_CHARTER_PRINCIPLE_CHIPS",
  BRAND_CHARTER_PRINCIPLE_TINT: "BRAND_CHARTER_PRINCIPLE_TINT",
  BRAND_CHARTER_PRINCIPLE_MOBILE: "BRAND_CHARTER_PRINCIPLE_MOBILE",
  BRAND_CHARTER_PRINCIPLE_TRUNCATE: "BRAND_CHARTER_PRINCIPLE_TRUNCATE",
  BRAND_CHARTER_PRINCIPLE_REUSE: "BRAND_CHARTER_PRINCIPLE_REUSE",
  BRAND_CHARTER_ASSETS_TITLE: "BRAND_CHARTER_ASSETS_TITLE",
  BRAND_CHARTER_ASSETS_TEXT: "BRAND_CHARTER_ASSETS_TEXT",
  BRAND_CHARTER_ASSETS_LOGOS: "BRAND_CHARTER_ASSETS_LOGOS",
  BRAND_CHARTER_ASSETS_FONTS: "BRAND_CHARTER_ASSETS_FONTS",
  BRAND_CHARTER_ASSETS_DOWNLOAD: "BRAND_CHARTER_ASSETS_DOWNLOAD",
  BRAND_CHARTER_ASSETS_LICENCE: "BRAND_CHARTER_ASSETS_LICENCE",
  BRAND_CHARTER_LOGO_SOURCE: "BRAND_CHARTER_LOGO_SOURCE",
  BRAND_CHARTER_LOGO_SQUARE: "BRAND_CHARTER_LOGO_SQUARE",
  BRAND_CHARTER_LOGO_APP: "BRAND_CHARTER_LOGO_APP",
  BRAND_CHARTER_NOTES_TITLE: "BRAND_CHARTER_NOTES_TITLE",
  BRAND_CHARTER_NOTES_TEXT: "BRAND_CHARTER_NOTES_TEXT",
  BRAND_CHARTER_NOTE_TENANT_TITLE: "BRAND_CHARTER_NOTE_TENANT_TITLE",
  BRAND_CHARTER_NOTE_CONTRAST_TITLE: "BRAND_CHARTER_NOTE_CONTRAST_TITLE",
  BRAND_CHARTER_TENANT_NOTE: "BRAND_CHARTER_TENANT_NOTE",
} as const;
